import { tuple } from './type';
export var PresetColorTypes = tuple('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime');


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/_util/colors.js
// module id = 364
// module chunks = 14